import { SystemMessagesProps } from "components/system-messages/types";
import sysMsg from "managers/sysMsg";
import { Component, SyntheticEvent } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./SystemMessages.css";

const mapStateToProps = (state:AppState):SystemMessagesProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		systemMessages: state.systemMessages,
	};
};

class SystemMessages extends Component<SystemMessagesProps.Component> {
	render():JSX.Element{
		return (
			<div id="sys-msg-container">
				{this.props.systemMessages.map((sysmsg) => {
					const title = sysmsg.title ? <h3>{t.t(sysmsg.title, sysmsg.titlePlaceholders)}</h3> : null;
					const message = sysmsg.message ? <p>{t.t(sysmsg.message, sysmsg.messagePlaceholders)}</p> : null;
					this.timeoutMsg(sysmsg.id, sysmsg.timeout);
					return (
						<div key={`sysmsg_${sysmsg.id}`}className={`sys-message ${sysmsg.type}`} onClick={this.dismissMessage} data-id={sysmsg.id}>
							{title}{message}
						</div>
					);
				})}
			</div>
		);
	}

	dismissMessage = (evt:SyntheticEvent):void => {
		const ele = evt.currentTarget;
		const id = ele.getAttribute("data-id");
		if(!id){ return; }
		sysMsg.dismiss(parseInt(id));
	}

	timeoutMsg = (id:number, timeoutInMS:number):void => {
		if(timeoutInMS === 0){ return; }
		setTimeout(() => { sysMsg.dismiss(id); }, timeoutInMS);
	}
}
export default connect(mapStateToProps)(SystemMessages);
